export default __webpack_public_path__ + "static/media/Punjabi-Kada.d0b7c006.jpg";